export default __webpack_public_path__ + "static/genopets-2-f-8965be1d97d2cf08e1a5f144bba70d61.webp";